/* ==========================================================================
   BELORA — SKIMS PURE · footer akordeonu

   DÜZELTME (12 Eyl, tmp-sk-footer). Buradaki eski not "panel ANINDA açılır
   (300ms boyunca 20 rAF örneğinin hepsi aynı yüksekliği okudu)" diyordu.
   YANLIŞTI — ve nedeni ölçümün kendisiydi: o tur referansın telefon
   footer'ındaki satırları BULAMAMIŞTI (satırlar `button`/`summary` diye
   aranmıştı; oysa etiket `button[aria-expanded]` İÇİNDEKİ bir div'de duruyor).
   Hiç açılmayan bir panel elbette hep aynı yüksekliği okur.

   Satırın kendisi bulunup dokunulduğunda referans şunu yapıyor (390, footer'ın
   kendi yüksekliği her karede örneklendi):
     AÇILIŞ   ~217ms · 1007 → 1255 · YAVAŞ başlar, HIZLI biter
              (zamanın yarısında yolun ~%22'si → cubic-bezier(.8, 0, 1, 1))
     KAPANIŞ  ~300ms · 1255 → 1007 · HIZLI başlar, YAVAŞ biter
              (zamanın yarısında yolun ~%84'ü → cubic-bezier(0, 0, .2, 1))
     dokunuş ile hareketin başlaması arasında ~290ms React gecikmesi var;
     o gecikme KOPYALANMIYOR — bizde hareket dokunuşta başlar.
     satır kutusu 342×52 (yanlarda 24), etiket Inter 16/24 w700,
     açılan bağlantılar Inter 12/28 (T65 burada da doğrulandı).

   Yükseklik `max-block-size` ile canlandırılır; kapanışta `hidden` ancak
   hareket bittikten sonra konur, böylece geçiş kesilmez. Açılış bitince kapak
   kaldırılır: içerik sonradan büyürse (uzun bağlantı, satır kayması) kırpılmaz.
   ========================================================================== */

(function () {
  'use strict';

  var footer = document.querySelector('.sk-footer');
  if (!footer) return;

  var OPEN_MS = 220;
  var CLOSE_MS = 300;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setOpen(btn, panel, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel._skTimer) { clearTimeout(panel._skTimer); panel._skTimer = 0; }

    if (still.matches) {
      panel.hidden = !open;
      panel.style.removeProperty('max-block-size');
      return;
    }

    if (open) {
      panel.hidden = false;
      panel.style.maxBlockSize = '0px';
      void panel.offsetHeight;                       // paint the closed state first
      panel.style.maxBlockSize = panel.scrollHeight + 'px';
      panel._skTimer = setTimeout(function () {
        panel._skTimer = 0;
        if (btn.getAttribute('aria-expanded') === 'true') panel.style.removeProperty('max-block-size');
      }, OPEN_MS);
      return;
    }

    panel.style.maxBlockSize = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.style.maxBlockSize = '0px';
    panel._skTimer = setTimeout(function () {
      panel._skTimer = 0;
      if (btn.getAttribute('aria-expanded') !== 'true') {
        panel.hidden = true;
        panel.style.removeProperty('max-block-size');
      }
    }, CLOSE_MS);
  }

  footer.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sk-foot-acc]');
    if (!btn) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    setOpen(btn, panel, btn.getAttribute('aria-expanded') !== 'true');
  });

  /* The accordion only exists below 1024. Crossing up to the column layout
     leaves aria-expanded="true" on a button that is now display:none, which is
     harmless visually but wrong for assistive tech — reset it. */
  var desktop = window.matchMedia('(min-width: 1024px)');
  function sync() {
    if (!desktop.matches) return;
    Array.prototype.forEach.call(footer.querySelectorAll('[data-sk-foot-acc]'), function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      if (panel._skTimer) { clearTimeout(panel._skTimer); panel._skTimer = 0; }
      panel.hidden = true;
      panel.style.removeProperty('max-block-size');
    });
  }
  desktop.addEventListener('change', sync);
  sync();
})();
